// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name, other, w = 22, h = 22) =>
  other ? (
    <img
      alt="navIcon"
      src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.${other}`}
      style={{ width: w, height: h }}
    />
  ) : (
    <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  );

const Transactions = [
  {
    title: 'Orders',
    path: '/dashboard/transactions/Orders',
    icon: icon('user'),
    ShortName: 'User_Master',
  },
];

export default Transactions;
